import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThreeDotHoriz = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 4,
	viewBox: "0 0 16 4",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.99967 2.0013C2.99967 2.46154 2.62658 2.83463 2.16634 2.83463C1.7061 2.83463 1.33301 2.46154 1.33301 2.0013C1.33301 1.54106 1.7061 1.16797 2.16634 1.16797C2.62658 1.16797 2.99967 1.54106 2.99967 2.0013Z",
			stroke: "#71717A",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.83301 2.0013C8.83301 2.46154 8.45991 2.83463 7.99967 2.83463C7.53944 2.83463 7.16634 2.46154 7.16634 2.0013C7.16634 1.54106 7.53944 1.16797 7.99967 1.16797C8.45991 1.16797 8.83301 1.54106 8.83301 2.0013Z",
			stroke: "#71717A",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.6663 2.0013C14.6663 2.46154 14.2932 2.83463 13.833 2.83463C13.3728 2.83463 12.9997 2.46154 12.9997 2.0013C12.9997 1.54106 13.3728 1.16797 13.833 1.16797C14.2932 1.16797 14.6663 1.54106 14.6663 2.0013Z",
			stroke: "#71717A",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgThreeDotHoriz);
export default ForwardRef;
